import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// material-ui
import { Button, Tooltip } from "@mui/material";

import { getSportCourtTypes, updateSportCourtTypeIndex } from "services/sportCourtTypeServices";
import AddSportCategoryDialog from "./_addSportCourtTypeDialog";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";
import TableV2Component from "components/TopCourtComponents/Table/Tablev2Component";
import { checkIsSAdmin } from "helper/Admin";

import SwapVertIcon from '@mui/icons-material/SwapVert';
import TocIcon from '@mui/icons-material/Toc';
import { DragIndicator } from "@mui/icons-material";

export default function SportCategoryComponent({
    merchantId, placeId
}) {
    const [isLoading, setLoading] = useState(true)
    const [isSort, setIsSort] = useState(false)
    const [rows, setRows] = useState([]);
    const [dialog, setDialog] = useState({
        open: false,
        data: null,
    });

    const loadData = async () => {
        try {
            let { data, error } = await getSportCourtTypes(
                merchantId, placeId
            );
            if (error) throw error;
            if (data) {
                setRows(data);
                setLoading(false)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    const valueCustomator = (row) => {
        return ({
            name: <div style={{ display: 'flex' }}>{ isSort && <DragIndicator sx={{ color: 'gray' }} /> }
                { isSort && 
                    <TCLabel style={{ marginTop: 4, marginLeft: 4 }}>{row.sportTypeId?.name ?? '-'}</TCLabel>
                }
                { !isSort &&
                    <TCLabel>{row.sportTypeId?.name ?? '-'}</TCLabel>
                }
            </div>,
            courtType: <TCLabel>{row.courtTypeId?.name ?? '-'}</TCLabel>,
        })
    }

    const updateIndex = () => {
        try {

        } catch (e) {

        }
    }

    const udpateSportCourtTypeIndex = async (e) => {
        try {
            console.log(e)
            // map the data first
            let body = []
            for (let i = 0; i < e.length; i++) {
                body.push({
                    _id: e[i]._id,
                    index: i
                })
            }
            let { data, error } = await updateSportCourtTypeIndex({
                indexData: body
            })
            if (error) { throw error }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>

            {
                checkIsSAdmin() &&
                <Tooltip title={isSort ? "View List Sport Court" : "Sort Sport Court Priority"}>
                    <Button sx={{ mb: 2, mr: 1 }} variant="contained" disableElevation
                        onClick={() => {
                            setLoading(true)
                            setIsSort(!isSort)
                            loadData();
                            setRows([])
                        }}
                    >
                        {!isSort ?
                            <SwapVertIcon />
                            :
                            <TocIcon />
                        }
                    </Button>
                </Tooltip>
            }
            <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={() => {
                setDialog({ open: true });
            }}>Add Sport Category</Button>
            {
                isSort ?
                    <TableV2Component
                        columns={[
                            { label: "Sport Category" },
                            { label: "Court Type" },
                        ]}
                        rows={rows}
                        valueCustomator={valueCustomator}
                        onDragEnd={(e) => {
                            udpateSportCourtTypeIndex(e)
                        }}
                    />
                    :
                    <TableComponent
                        columns={[
                            { label: "Sport Category" },
                            { label: "Court Type" },
                        ]}
                        rows={rows}
                        valueCustomator={valueCustomator}
                        loading={isLoading}
                    />
            }
            <AddSportCategoryDialog merchantId={merchantId} placeId={placeId} setDialog={dialog} handleClose={() => {
                setDialog({
                    open: false,
                    data: null,
                });
                loadData();
            }} />
        </>
    );
}
